import React from 'react'
import { Page, Card, DataTable, Loading, Pagination } from '@shopify/polaris'
import Api from '../../lib/api';


class Customers extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            customers: [],
            currentPage: 1,
            perPage: 10,
            totalPages: 1
        }
    }

    componentDidMount() {
        this.loadData(1)
    }
    loadData = (page) => {
        Api.getCustomers(page, this.state.perPage)
            .then(({ data }) => {
                this.setState({
                    loading: false,
                    customers: data.data,
                    currentPage: data.current_page,
                    totalPages: data.last_page
                })
            })
    }

    loadNextPage = () => {
        console.log('loading next page')
        if (this.state.currentPage < this.state.totalPages) {
            this.setState({ loading: true })
            let nextPage = this.state.currentPage + 1
            this.loadData(nextPage)
        }
    }
    loadPreviousPage = () => {
        console.log('loading previosu page')
        if (this.state.currentPage > 1) {
            this.setState({ loading: true })
            let prevPage = this.state.currentPage - 1
            this.loadData(prevPage)
        }
    }


    render() {
        const customers = this.state.customers
        const rows = customers.map(function (customer, index) {
            return [index + 1, `${customer.first_name} ${customer.last_name}`, customer.email, customer.referrer]
        })
        console.log(this.state)


        return (

            <Page
                title="Customers"
                primaryAction={{
                    content: "See Reports",
                    url: '/reports'
                }}
            >
                {this.state.loading && <Loading />}
                <Card>
                    <DataTable
                        columnContentTypes={[
                            'numeric',
                            'text',
                            'text',
                            'text'
                        ]}
                        headings={[
                            '#',
                            'Name',
                            'Email',
                            'Referrer'
                        ]}
                        rows={rows}
                    />

                </Card>
                <Pagination
                    hasNext={this.state.currentPage < this.state.totalPages}
                    hasPrevious={this.state.currentPage > 1}
                    label={`${this.state.currentPage} of ${this.state.totalPages}`}
                    onNext={this.loadNextPage}
                    onPrevious={this.loadPreviousPage}
                />
            </Page>
        );
    }
}

export default Customers
